import CSS from 'csstype';

import { FONT_WEIGHT, fontSizing } from '~/src/dash/components/text/common';

export type SimpleTextToggleSize = 'small' | 'base';

export const simpleTextToggleSizeStyle = (size: SimpleTextToggleSize): CSS.Properties => {
  switch (size) {
    case 'small':
      return {
        fontSize: fontSizing.small,
        padding: '4px 8px',
        borderRadius: '4px',
      };
    case 'base':
    default:
      return {
        fontSize: fontSizing.base,
        padding: '6px 10px',
        borderRadius: '6px',
        fontWeight: FONT_WEIGHT.bold,
      };
  }
};
